module.exports = __webpack_public_path__ + "img/807.cb3d5830.png";